// 관세사 메시지 인박스 (업체) — 관세사와의 통관 메모/문의 스레드 (P2, 2026-06-02)
//   백엔드: GET /clearance/threads, GET/POST /clearance/requests/:id/messages
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';

var NAVY = '#1B3A5C';

function ClearanceMessageInbox({ showToast }) {
  var st = showToast || function () {};
  var threadsState = useState([]); var threads = threadsState[0]; var setThreads = threadsState[1];
  var loadingState = useState(true); var loading = loadingState[0]; var setLoading = loadingState[1];
  var openState = useState(null); var openThread = openState[0]; var setOpenThread = openState[1]; // {requestId, carNo}
  var msgsState = useState([]); var msgs = msgsState[0]; var setMsgs = msgsState[1];
  var inputState = useState(''); var input = inputState[0]; var setInput = inputState[1];

  function loadThreads() {
    setLoading(true);
    authFetch(API + '/clearance/threads').then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) setThreads(d.items || []); setLoading(false); })
      .catch(function () { setLoading(false); });
  }
  useEffect(function () { loadThreads(); }, []);
  useEffect(function () {
    var sock = getSocket(); if (!sock) return;
    function onMsg() { loadThreads(); if (openThread) loadMsgs(openThread.requestId); }
    sock.on('clearance:message', onMsg);
    return function () { try { sock.off('clearance:message', onMsg); } catch (e) {} };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openThread]);

  function loadMsgs(reqId) {
    authFetch(API + '/clearance/requests/' + reqId + '/messages').then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) setMsgs(d.messages || []); }).catch(function () {});
  }
  function open(t) { setOpenThread({ requestId: t.requestId, carNo: t.carNo, agencyName: t.agencyName }); setInput(''); loadMsgs(t.requestId); }
  function post() {
    if (!openThread || !input.trim()) return;
    authFetch(API + '/clearance/requests/' + openThread.requestId + '/messages', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ body: input }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { setInput(''); loadMsgs(openThread.requestId); loadThreads(); } else st((d && d.error) || '전송 실패', 'err'); })
      .catch(function () { st('전송 실패', 'err'); });
  }

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1000, margin: '0 auto' }}>
      <div style={{ fontSize: 22, fontWeight: 800, color: NAVY, marginBottom: 4 }}>{'💬 관세사 메시지'}</div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 20 }}>{'관세사와 통관 관련 메모/문의를 주고받습니다.'}</div>

      {loading && <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>{'불러오는 중...'}</div>}
      {!loading && threads.length === 0 && (
        <div style={{ padding: 50, textAlign: 'center', color: '#94a3b8', background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 32, opacity: 0.4 }}>{'💬'}</div>
          <div style={{ marginTop: 8 }}>{'메시지가 없습니다'}</div>
        </div>
      )}
      {!loading && threads.map(function (t) {
        var unread = t.lastSender === 'broker';
        return (
          <div key={t.requestId} onClick={function () { open(t); }} style={{ background: '#fff', border: '1px solid ' + (unread ? '#bfdbfe' : '#e5e7eb'), borderLeft: '4px solid ' + (unread ? '#2563eb' : '#cbd5e1'), borderRadius: 10, padding: '12px 16px', marginBottom: 10, cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 15, fontWeight: 800, color: NAVY }}>{t.carNo}</span>
                  <span style={{ fontSize: 12, color: '#64748b' }}>{t.carType}</span>
                  {unread && <span style={{ fontSize: 10, fontWeight: 700, color: '#fff', background: '#2563eb', borderRadius: 8, padding: '1px 7px' }}>{'새 메시지'}</span>}
                </div>
                <div style={{ fontSize: 12, color: '#64748b', marginTop: 3 }}>{'관세사: ' + (t.agencyName || '-')}</div>
                <div style={{ fontSize: 13, color: '#334155', marginTop: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{(t.lastSender === 'broker' ? '관세사: ' : '나: ') + (t.lastBody || '')}</div>
              </div>
              <div style={{ fontSize: 11, color: '#94a3b8', whiteSpace: 'nowrap' }}>{(t.lastAt || '').slice(5, 16) + '  ›'}</div>
            </div>
          </div>
        );
      })}

      {openThread && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }} onClick={function () { setOpenThread(null); }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 20, width: 440, maxWidth: '92vw', display: 'flex', flexDirection: 'column', maxHeight: '80vh' }} onClick={function (e) { e.stopPropagation(); }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: NAVY }}>{'💬 ' + (openThread.carNo || '')}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 12 }}>{'관세사: ' + (openThread.agencyName || '-')}</div>
            <div style={{ flex: 1, overflowY: 'auto', background: '#f8fafc', borderRadius: 8, padding: 10, marginBottom: 10, minHeight: 120 }}>
              {msgs.length === 0 && <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: 12, padding: 20 }}>{'아직 메시지가 없습니다'}</div>}
              {msgs.map(function (m) {
                var mine = m.sender === 'company';
                return (
                  <div key={m.id} style={{ display: 'flex', justifyContent: mine ? 'flex-end' : 'flex-start', marginBottom: 6 }}>
                    <div style={{ maxWidth: '78%', background: mine ? NAVY : '#fff', color: mine ? '#fff' : '#334155', border: mine ? 'none' : '1px solid #e5e7eb', borderRadius: 10, padding: '7px 11px' }}>
                      <div style={{ fontSize: 13, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{m.body}</div>
                      <div style={{ fontSize: 10, color: mine ? '#cbd5e1' : '#94a3b8', marginTop: 3, textAlign: 'right' }}>{(mine ? '나' : '관세사') + ' · ' + (m.createdAt || '').slice(5, 16)}</div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <input value={input} onChange={function (e) { setInput(e.target.value); }} onKeyDown={function (e) { if (e.key === 'Enter') post(); }} placeholder="메시지 입력 후 Enter" style={{ flex: 1, padding: '9px 12px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 13, boxSizing: 'border-box' }} />
              <button onClick={post} style={{ padding: '9px 16px', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'전송'}</button>
            </div>
            <button onClick={function () { setOpenThread(null); }} style={{ marginTop: 8, padding: '8px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'닫기'}</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ClearanceMessageInbox;
